export const formatarMoeda = (valor: number): string => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(valor);
};

export const formatarNumero = (valor: number, casasDecimais: number = 2): string => {
  return valor.toFixed(casasDecimais);
};

export const formatarArea = (valor: number): string => {
  return valor.toFixed(2);
};

export const calcularPercentual = (valor: number, base: number): number => {
  if (base === 0) return 0;
  return ((valor - base) / base) * 100;
};
